import { render, staticRenderFns } from "./EditAdministratorForm.vue?vue&type=template&id=04923f32"
import script from "./EditAdministratorForm.vue?vue&type=script&lang=js"
export * from "./EditAdministratorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports